import I from '../types.ts';

const updateHandler: I['updateHandler'] = function (this: I) {
    const { currents } = this.props;

    this.setState({ currents: currents?.map((id) => ({ id })), isInit: true });
};

export default updateHandler;
